import type from './type';

const INITIAL_STATE = {
  loading: false,
  list: [],
  total: 0,
  campaignsLoading: false,
  campaigns: [],
  couponsLoading: false,
  coupons: [],
  basic: {},
  data: {},
  dataLoading: true,
  graphsLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.CAMPAIGNS_FETCHED:
      return { ...state, campaigns: action.payload, campaignsLoading: false };
    case type.CAMPAIGNS_LOAD:
      return { ...state, campaignsLoading: action.payload };
    case type.CUPOM_OFFERS_ESTABLISHMENT_FETCHED:
      return { ...state, coupons: action.payload, couponsLoading: false };
    case type.CUPOM_OFFERS_ESTABLISHMENT_LOAD:
      return { ...state, couponsLoading: action.payload };
    case type.BASIC_GRAPHS_FETCHED:
      return {
        ...state,
        basic: action.payload || null,
        graphsLoading: false,
      };

    case type.BASIC_GRAPH_LOAD:
      return {
        ...state,
        graphsLoading: action.payload,
      };

    case 'ADMIN_DATA_FETCHED':
      return { ...state, data: action.payload, dataLoading: false };
    case 'ADMIN_DATA_LOAD':
      return { ...state, dataLoading: action.payload };
    default:
      return state;
  }
};
